const prod = process.env.NODE_ENV === "production"

export const ADMIN_LEGACY_API_URL =
  process.env.REACT_APP_ADMIN_API_URL ??
  (prod ? "/api/admin" : "http://localhost:3000/api/admin")

export const ADMIN_V1_API_URL =
  process.env.REACT_APP_ADMIN_V1_API_URL ??
  (prod ? "/api/v1/admin" : "http://localhost:3000/api/v1/admin")
